import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  FormControl,
  Input,
  Button,
  InputGroup,
  Stack,
  Link,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import logoLogin from "../../assets/images/logo-main.png";
import background from "../../assets/images/background-login.png";
import toast from "react-hot-toast";
import { employeeCall } from "../../api/employee";
import { useNavigate } from "react-router-dom";
const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      resetOtp: "",
    },
  });
  const navigate = useNavigate(); 

  useEffect(()=>{
    document.cookie = "accessTokenForgot=; path=/; max-age=0";
  },[])

  const changeOTP = () => {
    clearErrors("resetOtp");
  };

  const sendOTP = async () => {
    const toastCreate = toast.loading("Đang gửi email ...");
    try {
      await employeeCall.sendOtp({
        email: getValues("email"),
      });

      toast.success("Gửi thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleForgot = async (data) => {
    const toastCreate = toast.loading("Đang xác nhận ...");
    try {
      const response = await employeeCall.verifyOtp(data);
      if (response?.accessToken) {
        document.cookie = `accessTokenForgot=${
          response.accessToken
        }; path=/; max-age=${1 * 24 * 60 * 60}`;
      }
      toast.success("Xác nhận thành công");
      navigate("/change-password");
    } catch (error) {
      if (error.status === 410) {
        setError("resetOtp", {
          message: "Mã OTP đã hết hạn, vui lòng ấn lấy lại mã!",
        });
      } else if (error.status !== 200) {
        setError("resetOtp", { message: "Mã OTP không trùng khớp!" });
      }

      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Flex
      backgroundImage={`url(${background})`}
      backgroundRepeat={"no-repeat"}
      backgroundColor="var(--color-background)"
      h={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Box
        padding={{ base: "40px" }}
        borderRadius={{ base: "16px" }}
        w={{ base: "500px" }}
        minHeight={{ base: "500px" }}
        backgroundColor="var(--color-main)"
        position={"relative"}
      >
        <Flex
          h={"100%"}
          w={"100%"}
          flexDirection={{ base: "column" }}
          alignItems={{ base: "center" }}
        >
          <Image src={logoLogin} />
          <Text
            fontSize={{ base: "26px" }}
            fontWeight={600}
            mt={{ base: "23px" }}
            mb={{ base: "36px" }}
          >
            Quên mật khẩu
          </Text>
          <Box w={"100%"}>
            <form onSubmit={handleSubmit(handleForgot)}>
              <Flex flexDirection={{ base: "column" }}>
                <FormControl mb={{ base: "16px" }}>
                  <Text fontSize={{ base: "12px" }} fontWeight={500}>
                    Email
                  </Text>
                  <InputGroup
                    alignItems={"center"}
                    gap={"8px"}
                    border={"1px solid #E1E1E1"}
                    mt={"8px"}
                    borderRadius={"8px"}
                    p={"0 8px"}
                    mb={"4px"}
                  >
                    <Input
                      flex={1}
                      type="email"
                      fontSize={{ base: "14px" }}
                      padding={"0px"}
                      borderRadius={"0px"}
                      border={"none"}
                      placeholder="Vui lòng nhập email"
                      _focus={{
                        boxShadow: "none",
                        borderColor: "#E1E1E1",
                      }}
                      {...register("email", {
                        required: "Email là bắt buộc",
                      })}
                    />
                    <Box
                      fontSize={{ base: "14px" }}
                      fontWeight={500}
                      color={"var(--color-option-employee-hover)"}
                      cursor={"pointer"}
                      w={"max-content"}
                      onClick={sendOTP}
                    >
                      Lấy mã
                    </Box>
                  </InputGroup>

                  {errors.email && (
                    <Text fontSize={{ base: "12px" }} color={"red"}>
                      {errors.email.message}
                    </Text>
                  )}
                </FormControl>
                <FormControl id="resetOtp" mb={{ base: "13px" }}>
                  <Text fontSize={{ base: "12px" }} fontWeight={500}>
                    Mã OTP
                  </Text>
                  <InputGroup
                    border={"1px solid #E1E1E1"}
                    borderRadius={"8px"}
                    p={"0 8px"}
                    mt={"8px"}
                    mb={"4px"}
                  >
                    <Input
                      fontSize={{ base: "14px" }}
                      padding={"0px"}
                      borderRadius={"0px"}
                      border={"none"}
                      type={"text"}
                      placeholder="Nhập mã OTP "
                      _focus={{
                        boxShadow: "none",
                        borderColor: "#E1E1E1",
                      }}
                      onChange={changeOTP}
                      {...register("resetOtp", {
                        required: "Mã OTP là bắt buộc",
                      })}
                    />
                    {/* {resetOtpValue && (
                      <InputRightElement>
                        <IconButton
                          _hover={{
                            bg: "var(--color-main)",
                          }}
                          backgroundColor={"none"}
                          icon={showPassword ? <ViewIcon /> : <ViewOffIcon />}
                          onClick={() => setShowPassword(!showPassword)}
                          variant="ghost"
                          aria-label={
                            showPassword ? "Hide resetOtp" : "Show resetOtp"
                          }
                        />
                      </InputRightElement>
                    )} */}
                  </InputGroup>
                  {errors.resetOtp && (
                    <Text fontSize={{ base: "12px" }} color={"red"}>
                      {errors.resetOtp.message}
                    </Text>
                  )}
                </FormControl>
                <Stack
                  fontSize={{ base: "12px" }}
                  direction="row"
                  justifyContent="flex-end"
                  align="center"
                  pb={{ base: "58px" }}
                >
                  <Link
                    href="/singin"
                    color="var(--color-option-employee-hover)"
                    fontSize={"13px"}
                    fontWeight={600}
                    lineHeight={"normal"}
                  >
                    Đăng nhập
                  </Link>
                </Stack>
                <Button
                  backgroundImage="var(--color-button)"
                  _hover={{
                    backgroundImage: "var(--color-button)",
                  }}
                  type="submit"
                >
                  <Text
                    color={"#FFF"}
                    fontSize={{ base: "15px" }}
                    fontWeight={700}
                  >
                    Xác nhận
                  </Text>
                </Button>
              </Flex>
            </form>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default ForgotPassword;
